import React from "react";

import { clientUrl } from "../../constants/site-urls";
import { createEvent } from "../../utils/create-event";

import heroImg from "./image.png";

const Hero = () => {
  return (
    <div className="relative isolate overflow-hidden bg-white">
      <svg
        className="absolute inset-0 -z-10 h-full w-full stroke-slate-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="0787a7c5-978c-4f66-83c7-11c213f99cb7"
            width={200}
            height={200}
            x="50%"
            y={-1}
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none" />
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth={0}
          fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
        />
      </svg>
      <div className="mx-auto max-w-7xl px-6 py-40 lg:flex lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:flex-shrink-0 lg:pt-8">
          <div>
            <a
              href="https://www.producthunt.com/posts/chrome-extension-kit?utm_source=badge-featured&amp;utm_medium=badge&amp;utm_souce=badge-chrome-extension-kit"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=243751&amp;theme=light"
                alt="Chrome Extension Kit - Chrome extension starter templates and examples | Product Hunt Embed"
                style={{ width: 175, height: 38 }}
                width="250px"
                height="54px"
              />
            </a>
          </div>
          <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-6xl">
            Launch your next Chrome Extension project fast.
          </h1>
          <p className="mt-4 text-lg leading-8 text-slate-700">
            Spend time working on your Chrome Extension, not setting up
            manifests and other boilerplate code. ExtensionKit is a collection
            of Chrome Extension starter templates, examples, and development
            scripts so you can focus on building.{" "}
            <b className="font-semibold underline">
              Built fully on Manifest V3.
            </b>
          </p>
          <div className="mt-10 flex flex-col sm:flex-row">
            <a
              href={`${clientUrl}/?ref=browse`}
              className="inline-flex rounded-lg text-sm font-semibold py-3 px-10 bg-emerald-500 border-2 border-emerald-500 text-white hover:bg-emerald-600 hover:border-emerald-600"
              onClick={() => {
                createEvent("View templates");
              }}
            >
              Browse templates & examples &rarr;
            </a>
          </div>
        </div>
        <div className="mt-10 lg:mt-0 lg:ml-16 flex items-center">
          <img
            src={heroImg}
            className="mx-auto w-full h-auto"
            alt="ExtensionKit icons"
            style={{ maxWidth: 600 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
